import React, { useContext } from 'react';

import { StaticContent } from 'types/StaticContent';

const defaultContent: StaticContent = {
  bookTimeDescription: `Som Arkivare (säljare hos Arkivet) kan du sälja de plagg du inte längre använder och få pengarna tillgodo hos Arkivet eller insatta på ditt bankkonto.`,
  bookTimePageText: `
Arkivet är en modern secondhandbutik med damkläder, skor, väskor och accessoarer för den modemedvetna kunden.

Vi tar in damkläder, skor, väskor & accessoarer som är i säsong, bra skick och modernt. Vi blandar kända märken med guldkorn från kedjorna.

Välkommen att boka inlämningstid i någon av våra butiker nedan.`,

  conditionDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Qua ex cognitione facilior facta est investigatio rerum occultissimarum. Ad quorum et cognitionem et usum iam corroborati natura ipsa praeeunte deducimur. Quod quidem iam fit etiam in Academia. Mihi enim satis est, ipsis non satis. Atqui reperies, inquit, in hoc quidem pertinacem; Duo Reges: constructio interrete. Tu autem negas fortem esse quemquam posse, qui dolorem malum putet.',
  myProductsForSaleDescription:
    'Dessa varor finns ute till försäljning i våra butiker. När försäljningsdagarna är slut hamnar osålda varor i fliken EJ SÅLDA varor. Du har därefter 7 dagar att hämta upp varan.',
  myProductsNotSoldDescription:
    'Om en vara inte hämtas inom 7 dagar efter försäljningsperiodens slut övergår äganderätten till varan till ARKIVET.',
  myProductsNotSoldHistoryDescription: 'Här ser du din historik på varor som inte blivit sålda.',
  myProductsSoldDescription:
    'Här ser du vilka av dina varor som har sålts, vilket datum de såldes och hur mycket du har tjänat på varje försäljning.',
  saldoPayoutDescription:
    'Välj belopp och klicka på knappen nedan för att genomföra utbetalningen. Vi tar ut en administrativ avgift om tio kronor (SEK 10) för varje utbetalning. Lägsta belopp att ta ut är 100 kr. Maxbelopp att ta ut är 15 000 kr.',
};

const StaticContentContext = React.createContext<StaticContent>(defaultContent);

export const useStaticContent = () => useContext(StaticContentContext);

export const StaticContentProvider: React.FC<{
  children: React.ReactNode;
  value: Partial<StaticContent>;
}> = props => {
  return (
    <StaticContentContext.Provider
      value={
        Object.fromEntries(
          (Object.entries(defaultContent) as [keyof StaticContent, string | undefined][]).map(
            ([key, value]) => [key, props.value[key] ?? value],
          ),
        ) as StaticContent
      }
    >
      {props.children}
    </StaticContentContext.Provider>
  );
};
